import { Link, Outlet } from 'react-router';
import { SiteNav } from '@/components/site-nav';
import { SiteFooter } from '@/components/site-footer';
import { PancakeCursor } from '@/components/pancake-cursor';

/**
 * Chrome shared by every page except the arcade.
 *
 * This was `(site)/layout.tsx`, one of two parallel root layouts. The <html>
 * and <body> halves of it now live in the seo.ts route table, because they
 * differ per route and have to be baked into the prerendered HTML; what is left
 * is the chrome itself.
 *
 * The arcade is deliberately not wrapped in this: it wants a full screen with
 * no announcement bar, no 76px sticky nav, no footer, and no PancakeCursor
 * chasing the pointer across the canvas at z-[100].
 */
export function SiteLayout() {
  return (
    <>
      {/* Ink band. One of the two background colours allowed per screen.
          The whole bar is the click target, and the focus ring is inset and
          yellow -- an ink ring on ink would be invisible, and an outset one
          would be clipped by the band's own edges. */}
      <div className="bg-bw-ink text-white">
        <Link
          to="/#pricing"
          className="block py-2.5 text-center transition-colors hover:text-bw-yellow focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-inset focus-visible:ring-bw-yellow"
        >
          <span className="bw-eyebrow">
            Plans from $500/month - no upfront fees
          </span>
        </Link>
      </div>

      <SiteNav />

      <Outlet />

      <SiteFooter />
      <PancakeCursor />
    </>
  );
}
